import Auth from "./API/Auth";
import Requirement from "./API/Requirement";
import MainProject from "./API/MainProject";
import Plan from "./API/Plan";
import CForm from "./API/CForm";
import AForm from "./API/AForm";
import BForm from "./API/BForm";
import Dashboard from "./API/Dashboard";
import MonthlyProgress from "./API/MonthlyProgress";
import Consider from "./API/Consider";
import Attachment from "./API/Attachment";
import Extend from "./API/Extend";
import USPExtend from "./API/USPExtend";
import RSPExtend from "./API/RSPExtend";
import SPExtend from "./API/SPExtend";
import Request from "./API/Request";
import UserServiceHistory from "./API/UserServiceHistory";
import CalendarActivity from "./API/CalendarActivity";
import TechnologyEvaluation from "./API/TechnologyEvaluation";
import Fundamental from "./API/Fundamental";
import Webboard from "./API/Webboard";

export default {
  Auth,
  Requirement,
  MainProject,
  Plan,
  CForm,
  AForm,
  BForm,
  Dashboard,
  MonthlyProgress,
  Consider,
  Attachment,
  Extend,
  USPExtend,
  RSPExtend,
  SPExtend,
  Request,
  UserServiceHistory,
  CalendarActivity,
  TechnologyEvaluation,
  Fundamental,
  Webboard
};
